import type { FishSpecies } from "@sikilesi/protocol";
import { navigate } from "./router";

/** Fish cut-outs (public/gol), with their intrinsic size so every image reserves its box (no layout shift). */
export const FISH_IMG: Readonly<Record<FishSpecies, { src: string; w: number; h: number }>> = {
  sazan: { src: "/gol/balik-sazan.webp", w: 300, h: 153 },
  yayin: { src: "/gol/balik-yayin.webp", w: 300, h: 110 },
  kefal: { src: "/gol/balik-kefal.webp", w: 300, h: 133 },
  turna: { src: "/gol/balik-turna.webp", w: 300, h: 100 },
};

/** Where the (at most six) fish swim, in % of the scene. */
export const LAKE_SLOTS: readonly { left: number; top: number; width: number; dur: number; delay: number }[] = [
  { left: 37, top: 70, width: 15, dur: 9, delay: 0 },
  { left: 60, top: 79, width: 14, dur: 11, delay: -3 },
  { left: 76, top: 64, width: 13, dur: 10, delay: -6 },
  { left: 24, top: 84, width: 13, dur: 12, delay: -2 },
  { left: 50, top: 60, width: 12, dur: 8, delay: -5 },
  { left: 84, top: 82, width: 12, dur: 13, delay: -7 },
];

/** Jump to the lake from anywhere ("[ GÖL · N balık oltada ]"). */
export function goToLake(): void {
  if (window.location.pathname !== "/") navigate("/");
  window.setTimeout(() => {
    document.getElementById("gol")?.scrollIntoView({ block: "start" });
  }, 60);
}
